
export const anonymousSurveyLink = (surveyId: string) => (
    `${window.location.origin}/public/survey/${surveyId}`
);

export const invitationSurveyLink = (token: string) => (
    `${window.location.origin}/public/survey/i/${token}`
);
